import { config, networks } from '../../config';
import * as Mainnet from './main';
import * as Testnet from './test';

export const address = config.stakingV1ContractAddress;

export const abi = config.net === networks.mainnet ? Mainnet?.abi : Testnet.abi;
